"use client";

import Link from "next/link";
import { useRef } from "react";
import { useTranslations } from "next-intl";
import Nav from "./Nav";
import MobileNav from "./MobileNav";
import { Button } from "./ui/button";
import LanguageSwitcher from "./LanguageSwitcher";
import NativeShareButton from "./NativeShareButton";

const Header = () => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const t = useTranslations("common.actions");

  const playHoverSound = () => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0; // Reset to start
      audioRef.current.play().catch((error) => {
        console.log("Audio play failed:", error);
      });
    }
  };

  return (
    <header className="py-6 xl:py-0 xl:h-16 text-white shrink-0 flex items-center">
      <audio ref={audioRef} preload="none">
        <source src="/glitch.wav" type="audio/wav" />
      </audio>
      <div className="container mx-auto flex justify-between items-center w-full">
        <Link
          href="/"
          className="cursor-target group"
          onMouseEnter={playHoverSound}
          onTouchStart={playHoverSound}
        >
          <span className="text-4xl font-semibold cursor-target relative overflow-hidden inline-block">
            <span className="inline-block transition-transform duration-500 group-hover:-translate-y-full">
              Parth
              <span className="text-accent">.</span>
            </span>
            <span className="absolute top-0 left-0 inline-block transition-transform duration-500 translate-y-full group-hover:translate-y-0">
              <span className="text-accent">પા</span>r
              <span className="text-accent">થ</span>
              <span className="text-accent">.</span>
            </span>
          </span>
        </Link>

        <div className="hidden xl:flex items-center gap-4">
          <Nav />
          <NativeShareButton />
          <Link href="/contact" className="cursor-target">
            <Button className="cursor-target">{t("contact")}</Button>
          </Link>
          <LanguageSwitcher compact />
        </div>

        <div className="xl:hidden">
          <MobileNav />
        </div>
      </div>
    </header>
  );
};

export default Header;
